<template>
    <div>
        <van-divider>基本信息</van-divider>
        <van-form ref="basicInfoForm" >
            <van-field label="申请人"
                       placeholder="请填写申请人姓名"
                       v-model="applyName"
                       :rules="[{ required:true, message: '请填写申请人姓名' }]"
            />
            <van-field
                    label="身份证号"
                    placeholder="请填写申请人身份证号"
                    v-model="applyIDNum"
                    :rules="[{ validator:idCardValidator, message: '请输入正确身份证号' }]"
            />

            <van-field label="电话"
                       placeholder="请填写联系电话"
                       v-model="phone"
                       :rules="[{pattern:/^1[3456789]\d{9}$/, required:true, message: '联系电话' }]"
            />
            <van-field name="gender" label="性别">
                <template #input>
                    <van-radio-group v-model="gender" direction="horizontal">
                        <van-radio name="1">男</van-radio>
                        <van-radio name="2">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                    readonly
                    clickable
                    name="birthday"
                    :value="birthday"
                    label="生日"
                    placeholder="请选择生日"
                    @click="showBirthDayPicker = true"
                    :rules="[{ required:true, message: '请选择生日' }]"
            />

            <van-field label="职业"
                       placeholder="请填写职业"
                       v-model="professional"
                       :rules="[{ required:true, message: '请填写职业' }]"
            />
            <van-field
                    readonly
                    clickable
                    name="national"
                    :value="national"
                    label="民族"
                    placeholder="请选择民族"
                    @click="showNationalPicker = true"
                    :rules="[{ required:true, message: '请选择民族' }]"
            />

            <van-field label="住址所在地"
                       placeholder="请填写住址"
                       v-model="address"
                       type="textarea"
                       autosize
                       :rules="[{ required:true, message: '请填写住址' }]"
            />
            <van-field label="案情"
                       placeholder="请填写案情"
                       v-model="theCase"
                       type="textarea"
                       rows="3"
                       autosize
                       maxlength="500"
                       show-word-limit
                       :rules="[{ required:true, message: '请填写案情' }]"
            />
        </van-form>
        <van-divider>身份证</van-divider>

        <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;">
            <div style="margin: 5px 10px;display: flex;flex-direction: column;align-items: center;justify-content: center" >
                <van-uploader
                        v-model="IDCardFrontFile"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'idCardImgA')"
                        :delete="()=>deleteImage('idCardImgA')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
                <div style="color: #969799;font-size: 14px;margin-top: 10px;">身份证正面</div>
            </div>
            <div style="margin: 5px 10px;display: flex;flex-direction: column;align-items: center;justify-content: center">
                <van-uploader
                        v-model="IDCardBackFile"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'idCardImgB')"
                        :delete="()=>deleteImage('idCardImgB')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
                <div style="color: #969799;font-size: 14px;margin-top: 10px;">身份证背面</div>
            </div>
        </div>

        <van-divider>其他资料（可选）</van-divider>
        <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;flex-wrap: wrap;">
                <van-uploader
                        v-model="image1"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'img1')"
                        :delete="()=>deleteImage('img1')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
               <van-uploader
                        v-if="image1.length>0"
                        v-model="image2"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'img2')"
                        :delete="()=>deleteImage('img2')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
               <van-uploader
                        v-if="image2.length>0"
                        v-model="image3"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'img3')"
                        :delete="()=>deleteImage('img3')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
                <van-uploader
                        v-if="image3.length>0"
                        v-model="image4"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'img4')"
                        :delete="()=>deleteImage('img4')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>
                <van-uploader
                        v-if="image4.length>0"
                        v-model="image5"
                        multiple
                        :max-count="1"
                        :afterRead="(file)=>afterRead(file,'img5')"
                        :delete="()=>deleteImage('img5')"
                >
                    <van-icon name="plus"  color="#969799" style = "border: 1px dashed #ebedf0" size = "50"/>
                </van-uploader>

       </div>

        <van-button round block slot="button" style=" width: 100%" type="primary" @click="submit">提交</van-button>

        <van-popup v-model="showBirthDayPicker" position="bottom">
            <van-datetime-picker
                    type="date"
                    v-model="currentDate"
                    @confirm="onPickBirthDay"
                    @cancel="showBirthDayPicker = false"
                    :min-date="minDate"
                    :max-date="maxDate"
            />
        </van-popup>

        <van-popup v-model="showNationalPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="nationals"
                    @confirm="onPickNational"
                    @cancel="showNationalPicker = false"
            />
        </van-popup>
    </div>
</template>

<script>
    import ClipboardJS from 'clipboard'
    import {Toast} from 'vant'
    import axios from 'axios'
    import moment from 'moment';
    import {responseCodes,consultStatus,userTypes} from '../../common/const'
    import COS from 'cos-js-sdk-v5'
  export default {
    name: "Assistance",
    data() {
      return {
        currentDate:new Date(1990,1,1),
        showNationalPicker:false,
        showBirthDayPicker:false,
        showImageOverlay:false,
        minDate: new Date(1900, 1, 1),
        maxDate: new Date(2025, 10, 1),
        overlayImageUrl:'',
        applyName:'',
        applyIDNum:'',
        phone:'',
        gender:"1",
        birthday:'',
        professional:'',
        national:'',
        address:'',
        theCase:'',
        idCard18Pattern:/^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/,
        idCard15Pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        IDCardFrontFile:[],
        IDCardBackFile:[],
        image1:[],
        image2:[],
        image3:[],
        image4:[],
        image5:[],
        nationals:['汉族','蒙古族','回族','藏族','维吾尔族','苗族','彝族','壮族','布依族','朝鲜族','满族','侗族','瑶族','白族','土家族','哈尼族','哈萨克族','傣族','黎族','僳僳族','佤族','畲族','高山族','拉祜族','水族','东乡族','纳西族','景颇族','柯尔克孜族', '土族','达斡尔族','仫佬族','羌族','布朗族','撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族','怒族','乌孜别克族','俄罗斯族','鄂温克族','德昂族','保安族','裕固族','京族','塔塔尔族','独龙族','鄂伦春族','赫哲族','门巴族','珞巴族','基诺族','其他'],
        cos:undefined,
        images:{
          idCardImgB:undefined,
          idCardImgA:undefined,
          img1:undefined,
          img2:undefined,
          img3:undefined,
          img4:undefined,
          img5:undefined
        }
      }
    },
    mounted(){
      console.info(ClipboardJS);
      new ClipboardJS('.copy-btn');
      this.cos= new COS({
        SecretId: 'AKIDxjGfqnHyINDsLauNuLXT9a8d7UAi3JL9',
        SecretKey: 'oTtxsa4II7h1ELI1UjncGo8F8mCQRDZq',
      })
    },
    methods:{
      showImage(imgUrl){
        this.overlayImageUrl =imgUrl;
        this.showImageOverlay =true;
      },
      afterRead(file,fileName){
        this.$store.commit('showOverlay');
        let appImg = file.file.name.substr(file.file.name.lastIndexOf('.'));
        this.cos.putObject({
          Bucket: 'jtfy-1301652109', /* 必须 */
          Region: 'ap-beijing',     /* 存储桶所在地域，必须字段 */
          Key: `/flyz/${fileName}-[${Math.floor(Math.random()*1000000000)}]${appImg}`,              /* 必须 */
          StorageClass: 'STANDARD',
          Body: file.file, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData));
          }
        }, (err, data)=> {
          if(data&&data.statusCode===200){
            this.images[fileName] = 'https://'+data.Location
          }else {
            Toast.fail('上传申请表失败');
          }
          this.$store.commit('hideOverlay');
        });
      },
      idCardValidator(val){
        if(!val){
          return false
        }
        return  this.idCard18Pattern.test(val)||this.idCard15Pattern.test(val);
      },

      onClickLeft() {
        this.$router.back();
      },

      onPickNational(value){
        this.national = value;
        this.showNationalPicker = false;
      },
      onPickBirthDay(date){
        this.birthday = moment(date).format("YYYY-MM-DD");
        this.showBirthDayPicker = false
      },

      deleteImage(fileName){
        //删除oss上照片
        this.images[fileName] == undefined;
      },
      uploadImage(){
      },
      async submit(){
          try {
            await this.$refs['basicInfoForm'].validate();
            if (!this.images.idCardImgA){
              Toast.fail('请上传身份证正面照片')
              return
            }

            if (!this.images.idCardImgB){
              Toast.fail('请上传身份证背面照片')
              return
            }


            this.$store.commit('showOverlay')

            let assistance = {
              openId:this.$store.state.user.openId,
              applyName:this.applyName,
              applyIDNum:this.applyIDNum,
              phone:this.phone,
              sex:this.gender,
              birthday:this.birthday,
              professional:this.professional,
              national:this.national,
              theCase:this.theCase,
              address:this.address,
              ...this.images
            }
            let response = await axios.post("/fyserve/apply/add" ,assistance)
            let data = response.data;
            if (data.code === responseCodes.success) {
              await axios.post(`/fyserve/apply/sub?applyId=${data.data.id}`);
              this.$emit('addassistance')
            }else{
              Toast.fail(data.message);
            }
          }catch (e) {
            console.error(e)
          }

        this.$store.commit('hideOverlay')
      },
    }
  }
</script>

<style scoped>

</style>